import axios from 'axios';

// Buat instance Axios
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Tambahkan interceptor untuk menyisipkan token ke setiap request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;